"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HistoryEventType;
(function (HistoryEventType) {
    HistoryEventType[HistoryEventType["ExecutionStarted"] = 0] = "ExecutionStarted";
    HistoryEventType[HistoryEventType["ExecutionCompleted"] = 1] = "ExecutionCompleted";
    HistoryEventType[HistoryEventType["ExecutionFailed"] = 2] = "ExecutionFailed";
    HistoryEventType[HistoryEventType["ExecutionTerminated"] = 3] = "ExecutionTerminated";
    HistoryEventType[HistoryEventType["TaskScheduled"] = 4] = "TaskScheduled";
    HistoryEventType[HistoryEventType["TaskCompleted"] = 5] = "TaskCompleted";
    HistoryEventType[HistoryEventType["TaskFailed"] = 6] = "TaskFailed";
    HistoryEventType[HistoryEventType["SubOrchestrationInstanceCreated"] = 7] = "SubOrchestrationInstanceCreated";
    HistoryEventType[HistoryEventType["SubOrchestrationInstanceCompleted"] = 8] = "SubOrchestrationInstanceCompleted";
    HistoryEventType[HistoryEventType["SubOrchestrationInstanceFailed"] = 9] = "SubOrchestrationInstanceFailed";
    HistoryEventType[HistoryEventType["TimerCreated"] = 10] = "TimerCreated";
    HistoryEventType[HistoryEventType["TimerFired"] = 11] = "TimerFired";
    HistoryEventType[HistoryEventType["OrchestratorStarted"] = 12] = "OrchestratorStarted";
    HistoryEventType[HistoryEventType["OrchestratorCompleted"] = 13] = "OrchestratorCompleted";
    HistoryEventType[HistoryEventType["EventSent"] = 14] = "EventSent";
    HistoryEventType[HistoryEventType["EventRaised"] = 15] = "EventRaised";
    HistoryEventType[HistoryEventType["ContinueAsNew"] = 16] = "ContinueAsNew";
    HistoryEventType[HistoryEventType["GenericEvent"] = 17] = "GenericEvent";
    HistoryEventType[HistoryEventType["HistoryState"] = 18] = "HistoryState";
})(HistoryEventType = exports.HistoryEventType || (exports.HistoryEventType = {}));
//# sourceMappingURL=historyeventtype.js.map